// Copyright ©️ 2026 eVolve MEP, LLC

import type { ButtonProps } from '@mantine/core';

import type { WorkOrderAction } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/useCanEditWorkOrder';
import type { WorkOrderActionButtonsProps } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/WorkOrderActionButtons';

/**
 * Actions after which the user stays on the current page (the work order is refetched in place) rather than
 * being sent back to the Work Orders list. Shared by the desktop `WorkOrderActionButtons` and mobile
 * `MobileWorkOrderActions` so their post-action navigation stays in lockstep.
 */
export const ACTIONS_REMAINING_ON_PAGE: readonly WorkOrderAction[] = [
  'submit',
  'approve',
  'block',
  'confirmTransfer',
  'denyCancel',
];

export const getActionButtonProps = ({
  inline,
  primary,
  disabled,
}: Pick<WorkOrderActionButtonsProps, 'inline' | 'primary' | 'disabled'>): ButtonProps => ({
  variant: primary && !inline ? 'filled' : 'light',
  size: inline ? 'compact-sm' : undefined,
  disabled,
  fullWidth: inline,
});
